
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
  super();

  // GQS: impiedica inchiderea modala la click pe
  // imagine sau pe butoanele de navigare.
  this.querySelectorAll(
    '.product-media-modal__content, .gqs-modal-nav'
  ).forEach((element) => {
    element.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'mouse') {
        event.stopPropagation();
      }
    });
  });

        this.currentIndex = 0;
        this.zoomed = false;
        this.touchStartX = null;
        this.touchStartY = null;
        this.touchStartCount = 0;

        this.content = this.querySelector(
          '.product-media-modal__content'
        );

        this.prevButton = this.querySelector('.gqs-modal-prev');
        this.nextButton = this.querySelector('.gqs-modal-next');

        this.prevButton?.addEventListener('click', () => {
          this.navigate(-1);
        });

        this.nextButton?.addEventListener('click', () => {
          this.navigate(1);
        });

        this.content?.addEventListener('click', (event) => {
          if (!event.target.closest('img')) return;
          this.toggleZoom(event.target);
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.navigate(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.navigate(1);
          }
        });

        this.content?.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartCount = event.touches.length;
            if (this.touchStartCount !== 1) {
              this.touchStartX = null;
              return;
            }
            this.touchStartX = event.touches[0].clientX;
            this.touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        this.content?.addEventListener(
          'touchend',
          (event) => {
            if (
              this.zoomed ||
              this.touchStartCount !== 1 ||
              this.touchStartX === null ||
              event.changedTouches.length !== 1
            ) return;

            const dx =
              event.changedTouches[0].clientX - this.touchStartX;
            const dy =
              event.changedTouches[0].clientY - this.touchStartY;

            this.touchStartX = null;

            if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              this.navigate(dx < 0 ? 1 : -1);
            }
          },
          { passive: true }
        );
      }

      get mediaItems() {
        return Array.from(
          this.content.querySelectorAll('[data-media-id]')
        );
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const index = this.mediaItems.findIndex(
          item => item.dataset.mediaId === mediaId
        );

        this.activateMedia(index >= 0 ? index : 0);
      }

      activateMedia(index) {
        const items = this.mediaItems;
        if (!items.length) return;

        this.resetZoom();

        this.currentIndex = (index + items.length) % items.length;

        items.forEach((item, i) => {
          item.classList.toggle('active', i === this.currentIndex);
        });

        const activeMedia = items[this.currentIndex];

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        this.content.scrollTop = 0;
        this.content.scrollLeft = 0;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('template .js-youtube')
        ) {
          activeMedia.loadContent();
        }

        const hasMultiple = items.length > 1;
        if (this.prevButton) this.prevButton.hidden = !hasMultiple;
        if (this.nextButton) this.nextButton.hidden = !hasMultiple;
      }

      navigate(direction) {
        if (this.zoomed) this.resetZoom();
        this.activateMedia(this.currentIndex + direction);
      }

      toggleZoom(image) {
        if (window.matchMedia('(max-width: 749px)').matches) return;

        if (this.zoomed) {
          this.resetZoom();
          return;
        }

        this.zoomed = true;
        image.classList.add('gqs-image-zoomed');
        this.content.classList.add('gqs-modal-is-zoomed');
      }

      resetZoom() {
        this.zoomed = false;
        this.content?.classList.remove('gqs-modal-is-zoomed');
        this.content
          ?.querySelectorAll('.gqs-image-zoomed')
          .forEach(image => image.classList.remove('gqs-image-zoomed'));
      }
    }
  );
}
